var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer-end"},[_c('div',{staticClass:"title"},[_vm._v("答题结束")]),_c('div',{staticClass:"view-score",on:{"click":_vm.viewScore}},[_vm._v("查看分数")])])
}
var staticRenderFns = []

export { render, staticRenderFns }